import type {
    CampoInventario,
    OrigenOpciones,
    ValoresFormularioInventario,
} from "../types/catalogoInventario.types";

export type TipoCampoInventario = "texto" | "seleccion";

export interface CampoFormularioInventario {
    nombre: CampoInventario;
    etiquetaId: string;
    tipo: TipoCampoInventario;
    columnas: number;
    requerido?: boolean;
    soloNumeros?: "entero" | "decimal";
    origenOpciones?: OrigenOpciones;
    soloAlCrear?: boolean;
}

export const CAMPOS_INVENTARIO: CampoFormularioInventario[] = [
    { nombre: "clave", etiquetaId: "input_clave", tipo: "texto", columnas: 6 },
    { nombre: "nombre", etiquetaId: "input_nombre", tipo: "texto", columnas: 6, requerido: true },
    { nombre: "precio", etiquetaId: "input_precio", tipo: "texto", columnas: 6, requerido: true, soloNumeros: "entero" },
    { nombre: "cantidad", etiquetaId: "input_cantidad", tipo: "texto", columnas: 6, requerido: true, soloNumeros: "entero", soloAlCrear: true },
    { nombre: "id_unidad_medida", etiquetaId: "select_unidad_medida", tipo: "seleccion", columnas: 6, requerido: true, origenOpciones: "unidadesMedida" },
    { nombre: "id_categoria", etiquetaId: "select_categoria", tipo: "seleccion", columnas: 6, requerido: true, origenOpciones: "categorias" },
    { nombre: "id_ubicacion", etiquetaId: "select_ubicacion", tipo: "seleccion", columnas: 6, requerido: true, origenOpciones: "ubicaciones" },
    { nombre: "id_tipo_producto", etiquetaId: "select_tipo_producto", tipo: "seleccion", columnas: 6, requerido: true, origenOpciones: "tipoProductos" },
    { nombre: "maximos", etiquetaId: "input_maximos", tipo: "texto", columnas: 4, requerido: true, soloNumeros: "entero" },
    { nombre: "minimos", etiquetaId: "input_minimos", tipo: "texto", columnas: 4, requerido: true, soloNumeros: "entero" },
    { nombre: "punto_reorden", etiquetaId: "input_punto_reorden", tipo: "texto", columnas: 4, requerido: true, soloNumeros: "entero" },
];

export const MENSAJE_SIN_OPCIONES: Record<OrigenOpciones, string> = {
    unidadesMedida: "sin_unidades_medida_registradas",
    categorias: "sin_categorias_registradas",
    ubicaciones: "sin_ubicaciones_registradas",
    tipoProductos: "sin_tipos_producto_registrados",
};

export const VALORES_INICIALES_INVENTARIO: ValoresFormularioInventario = {
    clave: "",
    nombre: "",
    precio: "",
    cantidad: "",
    id_unidad_medida: "",
    id_categoria: "",
    id_ubicacion: "",
    id_tipo_producto: "",
    maximos: "",
    minimos: "",
    punto_reorden: "",
};

export const COLORES_INVENTARIO = {
    primario: "#041d45",
    titulo: "#004c93",
    boton: "#084d6e",
    campoValido: "#00AB16",
    activo: "#21965c",
    inactivo: "#cc4343",
    textoChip: "#FFF9C4",
    qr: "#D4AF37",
    qrHover: "#a98c2c",
    qrTexto: "#3D3E3D",
    botonHover: "#063a53",
} as const;

export const ESTATUS_INVENTARIO = {
    activo: { label: "ACTIVADO", color: COLORES_INVENTARIO.activo },
    inactivo: { label: "DESACTIVADO", color: COLORES_INVENTARIO.inactivo },
} as const;


export const CARPETA_QR = "qr-generados";

export const MAX_QR_POR_LOTE = 200;
